const setting = {
  APP_BASE_URL: process.env.NEXT_PUBLIC_APP_BASE_URL,
  APP_IV: process.env.NEXT_PUBLIC_APP_IV,
  APP_ENCRYPTION_KEY: process.env.NEXT_PUBLIC_APP_ENCRYPTION_KEY,
  GOOGLE_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_API_KEY,
  APP_STORAGE_KEY: process.env.NEXT_PUBLIC_APP_STORAGE_KEY,
  PAYMENT_GATEWAY_MODE: process.env.NEXT_PUBLIC_APP_PAYMENT_GATEWAY_MODE,
  IMAGE_URL: process.env.NEXT_PUBLIC_IMAGE_URL,
};

export default setting;
